import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import default translation files
import en from './locales/en/translation-en.json';
import fr from './locales/fr/translation-fr.json';
import cn from './locales/cn/translation-cn.json';
import de from './locales/de/translation-de.json';
import es from './locales/es/translation-es.json';
import hi from './locales/hi/translation-hi.json';
import sa from './locales/sa/translation-sa.json';
import ka from './locales/ka/translation-ka.json';

// Function to load user-defined translations from localStorage
const loadUserDefinedTranslations = () => {
  try {
    const storedTranslations = localStorage.getItem('translations_ud');
    return storedTranslations ? JSON.parse(storedTranslations) : {};
  } catch (error) {
    // console.error('Failed to load user-defined translations:', error);
    return {};
  }
};

// Initial resources with default translations
const initialResources = {
  en: { translation: en },
  fr: { translation: fr },
  zh: { translation: cn },
  de: { translation: de },
  es: { translation: es },
  hi: { translation: hi },
  kn: { translation: ka },
  ar: { translation: sa },
  ud: { translation: loadUserDefinedTranslations() }
};

// Helper to get detected fallback language for User Defined (ud) translations
const getDetectedFallbackLang = () => {
  try {
    const sessionLang = sessionStorage.getItem('session_detected_lang');
    if (sessionLang && sessionLang !== 'ud') return sessionLang;
  } catch (e) { }
  return 'en';
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: initialResources,
    fallbackLng: {
      ud: [getDetectedFallbackLang(), 'en'],
      default: ['en']
    },
    debug: false,

    interpolation: {
      escapeValue: false,
    },
    // Add a custom load handler to update user-defined translations
    load: (languages, callback) => {
      languages.forEach(language => {
        if (language === 'ud') {
          const userDefinedTranslations = loadUserDefinedTranslations();

          // Clear existing ud resources
          Object.keys(i18n.store.data.ud || {}).forEach(namespace => {
            delete i18n.store.data.ud[namespace];
          });

          // Add user-defined translations
          Object.entries(userDefinedTranslations).forEach(([namespace, translations]) => {
            i18n.addResourceBundle('ud', namespace, translations, true, true);
          });
        }
      });
      callback(null, languages);
    }
  });

// Add a method to update user-defined translations
i18n.updateUserDefinedTranslations = (newTranslations) => {
  try {
    // Merge with existing translations
    const existingTranslations = loadUserDefinedTranslations();
    const mergedTranslations = {
      ...existingTranslations,
      ...newTranslations
    };

    // Save to localStorage
    localStorage.setItem('translations_ud', JSON.stringify(mergedTranslations));

    // Update i18next resources
    Object.entries(mergedTranslations).forEach(([namespace, translations]) => {
      i18n.addResourceBundle('ud', namespace, translations, true, true);
    });

    // Trigger language change to ud to refresh translations
    if (i18n.language === 'ud') {
      i18n.changeLanguage('ud');
    }
  } catch (error) {
    // console.error('Failed to update user-defined translations:', error);
  }
};

i18n.setDetectedFallback = (lang) => {
  if (lang && lang !== 'ud') {
    i18n.options.fallbackLng = {
      ud: [lang, 'en'],
      default: ['en']
    };
  }
};

export default i18n;